import { call, put, takeLatest } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import { HospitalNetworkApi } from '@apis/HospitalNetworkApi';
import { Hospital } from '@models/BusinessPartner';
import { Pagination } from '@models/Pagination';
import { hospitalsFetch, stateUpdate, StateUpdatePayload, HospitalsFetchPayload } from './action';

function* handleHospitalsFetch(action: Action<HospitalsFetchPayload>) {
  const state: StateUpdatePayload = { isLoading: true, error: null };
  yield put(stateUpdate(state));

  try {
    const [hospitals, pagination] = (yield call(HospitalNetworkApi.getAll, action.payload)) as [Hospital[], Pagination];

    yield put(
      stateUpdate({
        hospitals,
        pagination,
        searchParams: action.payload,
        isLoading: false,
        error: null,
      })
    );
  } catch (error) {
    console.error('Failed to fetch hospitals:', error);
    yield put(
      stateUpdate({
        hospitals: [],
        isLoading: false,
        error: 'Failed to load hospitals. Please try again later.',
      })
    );
  }
}

export default function* () {
  yield takeLatest(hospitalsFetch, handleHospitalsFetch);
}
